<script lang="ts">
    interface Props {
        name: string;
        mastery: number;
        target: number;
        description?: string;
        profession?: string;
    }
    let { name, mastery, target, description, profession }: Props = $props();

    let glowing = $state(false);
    let mounted = false;

    $effect(() => {
        void mastery; // track dependency
        if (!mounted) { mounted = true; return; }
        glowing = false;
        requestAnimationFrame(() => { glowing = true; });
    });
</script>

<div class="skill-plaque" class:glowing title={description}
     onanimationend={() => { glowing = false; }}>
    <div class="skill-profession">🎖️ {profession ?? name}</div>
    <div class="skill-stats">
        <span class="skill-mastery">+{mastery}</span>
        <span class="skill-target">🎯 {target}</span>
    </div>
</div>

<style>
    .skill-plaque {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
        padding: 0.3rem 0.5rem;
        border: 1px solid #8b6a30;
        background:
            radial-gradient(ellipse 80% 50% at 15% 15%, rgba(255, 250, 225, 0.4), transparent),
            radial-gradient(ellipse 60% 80% at 85% 85%, rgba(150, 110, 40, 0.18), transparent),
            linear-gradient(160deg, #ede0b0 0%, #e0ce90 50%, #d4be78 100%);
        box-shadow:
            inset 0 1px 0 rgba(255, 248, 210, 0.6),
            inset 0 -1px 0 rgba(80, 50, 10, 0.3),
            0 1px 4px rgba(0, 0, 0, 0.45);
        min-width: 5.5rem;
    }

    .skill-plaque.glowing {
        animation: diploma-glow 1.4s ease-out forwards;
    }

    @keyframes diploma-glow {
        0%   {
            filter: brightness(1);
            box-shadow:
                inset 0 1px 0 rgba(255, 248, 210, 0.6),
                inset 0 -1px 0 rgba(80, 50, 10, 0.3),
                0 1px 4px rgba(0, 0, 0, 0.45);
        }
        18%  {
            filter: brightness(1.4);
            box-shadow:
                inset 0 1px 0 rgba(255, 252, 220, 0.9),
                inset 0 -1px 0 rgba(80, 50, 10, 0.2),
                0 0 16px rgba(215, 175, 60, 0.85),
                0 0  6px rgba(255, 220, 80, 0.5);
        }
        100% {
            filter: brightness(1);
            box-shadow:
                inset 0 1px 0 rgba(255, 248, 210, 0.6),
                inset 0 -1px 0 rgba(80, 50, 10, 0.3),
                0 1px 4px rgba(0, 0, 0, 0.45);
        }
    }

    .skill-profession {
        font-size: 0.80rem;
        font-family: 'Courier New', Courier, monospace;
        font-weight: bold;
        color: #2a1808;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        text-align: center;
        line-height: 1;
    }

    .skill-stats {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }

    .skill-mastery {
        font-size: 0.80rem;
        font-family: 'Courier New', Courier, monospace;
        font-weight: bold;
        color: #2a1808;
    }

    .skill-target {
        font-size: 0.74rem;
        font-family: 'Courier New', Courier, monospace;
        font-weight: bold;
        color: #2a1808;
    }
</style>
